import React, { useState, useEffect, useContext } from "react";
import { Form, Alert, Badge, Button, Row, Col } from "react-bootstrap";
import api, { BASE_URL } from "../../../Utils/api";
import Modal from "react-bootstrap/Modal";
import {
  FiExternalLink,
  FiInfo,
  FiKey,
  FiLock,
  FiMail,
  FiServer,
  FiSettings,
  FiShield,
} from "react-icons/fi";
import { GlobalContext } from "../../../Utils/GlobalContext";
import { Salvar, Cancelar } from "../../Generals/buttons";
import { Senha } from "../../Generals/Inputs";
import { useFeedback } from "../../Generals/Feedback/FeedbackContext";
import "./EmailNotificacao.css";

const GoogleGIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const MicrosoftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" width="18" height="18" aria-hidden="true">
    <rect x="1"  y="1"  width="9" height="9" fill="#f25022"/>
    <rect x="11" y="1"  width="9" height="9" fill="#7fba00"/>
    <rect x="1"  y="11" width="9" height="9" fill="#00a4ef"/>
    <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
  </svg>
);


const normalizarMetodoAutenticacao = (valor) => {
  const bruto = String(valor || "SEM_AUTENTICACAO").trim().toUpperCase().replace(/\s+/g, " ");
  const mapa = {
    "SEM AUTENTICACAO": "SEM_AUTENTICACAO",
    "SENHA NORMAL": "SENHA_NORMAL",
    "SENHA CRIPTOGRAFADA": "SENHA_CRIPTOGRAFADA",
    KERBEROS_GSSAPI: "KERBEROS/GSSAPI",
  };
  return mapa[bruto] || bruto.replace(/\s+/g, "_").replace("KERBEROS_GSSAPI", "KERBEROS/GSSAPI");
};

const normalizarSegurancaConexao = (valor) => {
  const bruto = String(valor || "NENHUM").trim().toUpperCase();
  return bruto === "NENHUM" || bruto === "SSL/TSL" || bruto === "STARTTLS" ? bruto : "NENHUM";
};

const EmailNotificacaoModal = ({
  show,
  handleClose,
  configuracao,
  fetchConfiguracoes,
}) => {
  const [nome, setNome] = useState("");
  const [servidor, setServidor] = useState("");
  const [porta, setPorta] = useState("");
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [appName, setAppName] = useState("");
  const [appSenha, setAppSenha] = useState("");
  const [situacao, setSituacao] = useState("A");
  const [segurancaConexao, setSegurancaConexao] = useState("NENHUM");
  const [metodoAutenticacao, setMetodoAutenticacao] = useState("SEM_AUTENTICACAO");
  const [oauth2TenantId, setOauth2TenantId] = useState("");
  const [oauth2ClientId, setOauth2ClientId] = useState("");
  const [oauth2ClientSecret, setOauth2ClientSecret] = useState("");
  const [alertaConflito, setAlertaConflito] = useState("");
  const { toast } = useFeedback();
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");

  // Carrega a configuração ao abrir o modal; quando abre sem objeto (novo), limpa o formulário
  useEffect(() => {
    if (!show) return;
    setAlertaConflito("");
    if (configuracao) {
      setNome(configuracao.nome || "");
      setServidor(configuracao.servidor || "");
      setPorta(configuracao.porta || "");
      setUsuario(configuracao.usuario || "");
      setSenha(configuracao.senha || "");
      setAppName(configuracao.app_name || "");
      setAppSenha(configuracao.app_senha || "");
      setSituacao(configuracao.situacao || "A");
      setSegurancaConexao(normalizarSegurancaConexao(configuracao.seguranca_conexao));
      setMetodoAutenticacao(normalizarMetodoAutenticacao(configuracao.metodo_autenticacao));
      setOauth2TenantId(configuracao.oauth2_tenant_id || "");
      setOauth2ClientId(configuracao.oauth2_client_id || "");
      setOauth2ClientSecret(configuracao.oauth2_client_secret || "");
    } else {
      setNome("");
      setServidor("");
      setPorta("");
      setUsuario("");
      setSenha("");
      setAppName("");
      setAppSenha("");
      setSituacao("A");
      setSegurancaConexao("NENHUM");
      setMetodoAutenticacao("SEM_AUTENTICACAO");
      setOauth2TenantId("");
      setOauth2ClientId("");
      setOauth2ClientSecret("");
    }
  }, [show, configuracao]);

  const preencherGoogle = () => {
    setNome("Google");
    setServidor("smtp.gmail.com");
    setSegurancaConexao("SSL/TSL");
    setPorta("465");
    setMetodoAutenticacao("SENHA_NORMAL");
    setAlertaConflito("");
  };

  const preencherOutlook = () => {
    setNome("Outlook / Microsoft 365");
    setServidor("smtp.office365.com");
    setSegurancaConexao("STARTTLS");
    setPorta("587");
    setMetodoAutenticacao("OAUTH2_MICROSOFT_GRAPH");
    setAlertaConflito("");
  };

  const verificarCamposObrigatorios = () => {
    const faltantes = [];
    if (!nome.trim()) faltantes.push("Nome");
    if (!servidor.trim()) faltantes.push("Servidor");
    if (!String(porta).trim() && metodoAutenticacao !== "OAUTH2_MICROSOFT_GRAPH") {
      faltantes.push("Porta");
    }
    if (!usuario.trim()) faltantes.push("Usuário");

    if (
      metodoAutenticacao === "SENHA_NORMAL" ||
      metodoAutenticacao === "SENHA_CRIPTOGRAFADA" ||
      metodoAutenticacao === "NTLM"
    ) {
      if (!configuracao && !senha.trim()) faltantes.push("Senha");
    }

    if (metodoAutenticacao === "OAUTH2_MICROSOFT_GRAPH") {
      if (!oauth2TenantId.trim()) faltantes.push("Tenant ID");
      if (!oauth2ClientId.trim()) faltantes.push("Client ID");
      if (!configuracao && !oauth2ClientSecret.trim()) faltantes.push("Client Secret");
    }

    return faltantes;
  };

  const handleSave = async () => {
    setAlertaConflito("");

    const camposFaltantes = verificarCamposObrigatorios();
    if (camposFaltantes.length > 0) {
      const mensagem = `Os seguintes campos obrigatórios não foram preenchidos: ${camposFaltantes.join(", ")}.`;
      setAlertaConflito(mensagem);
      toast.error(mensagem);
      return;
    }

    const configuracaoData = {
      id_entidade: entidadeID,
      nome,
      servidor,
      porta,
      usuario,
      senha,
      app_name:  appName  || null,
      app_senha: appSenha || null,
      situacao,
      seguranca_conexao:    segurancaConexao,
      metodo_autenticacao:  metodoAutenticacao,
      oauth2_tenant_id:     oauth2TenantId    || null,
      oauth2_client_id:     oauth2ClientId    || null,
      oauth2_client_secret: oauth2ClientSecret || null,
    };

    try {
      if (configuracao) {
        await api.put(
          `${BASE_URL}/api/emailNotificacao/EditarConfiguracaoEmail/${configuracao.id}`,
          configuracaoData
        );
      } else {
        await api.post(
          `${BASE_URL}/api/emailNotificacao/InserirConfiguracaoEmail/${entidadeID}`,
          configuracaoData
        );
      }
      fetchConfiguracoes();
      handleClose();
      toast.success("Configuração de e-mail salva com sucesso.");
    } catch (err) {
      const mensagem =
        err.response?.data?.message ||
        "Erro ao salvar configuração de e-mail. Verifique os campos e tente novamente.";
      setAlertaConflito(mensagem);
      toast.error(mensagem);
    }
  };

  const servidorNormalizado = servidor.toLowerCase();
  const provedorDetectado =
    servidorNormalizado.includes("gmail") || servidorNormalizado.includes("smtp.google")
      ? "google"
      : servidorNormalizado.includes("outlook") ||
        servidorNormalizado.includes("office365") ||
        servidorNormalizado.includes("hotmail") ||
        servidorNormalizado.includes("live")
      ? "microsoft"
      : null;
  const exibirSenhaApp = Boolean(provedorDetectado || appSenha);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      size="xl"
      centered
      dialogClassName="email-config-dialog"
      contentClassName="email-config-modal"
    >
      <Modal.Header closeButton className="email-config-header">
        <div className="email-config-header-main">
          <div className="email-config-header-icon">
            <FiMail size={22} aria-hidden="true" />
          </div>
          <div>
            <span className="email-config-eyebrow">Canal de notificações</span>
            <Modal.Title>
              {configuracao ? "Configuração de Email" : "Adicionar Configuração de Email"}
            </Modal.Title>
            <p>Defina o remetente usado nos alertas de vencimento dos documentos.</p>
          </div>
        </div>
        <Badge bg={situacao === "A" ? "success" : "secondary"} pill className="email-config-status">
          {situacao === "A" ? "Ativa" : "Inativa"}
        </Badge>
      </Modal.Header>

      <Modal.Body className="email-config-body">
        <div className="email-provider-bar" data-tour="email-provedor-rapido">
          <div>
            <span className="email-config-eyebrow">Configuração rápida</span>
            <strong>Escolha um provedor para preencher os dados principais</strong>
          </div>
          <div className="email-provider-actions">
            <Button type="button" variant="outline-secondary" onClick={preencherGoogle}>
              <GoogleGIcon />
              Gmail
            </Button>
            <Button type="button" variant="outline-secondary" onClick={preencherOutlook}>
              <MicrosoftIcon />
              Outlook / Microsoft 365
            </Button>
          </div>
        </div>

        {alertaConflito && (
          <Alert variant="danger" className="email-config-alert">
            <FiInfo aria-hidden="true" />
            <span>{alertaConflito}</span>
          </Alert>
        )}

        <Form className="email-config-form">
          <section className="email-config-card">
            <div className="email-config-section-title">
              <FiSettings aria-hidden="true" />
              <div>
                <h3>Identificação</h3>
                <p>Nome interno e disponibilidade desta configuração.</p>
              </div>
            </div>
            <Row className="g-3">
              <Col md={8}>
                <Form.Group controlId="formNome">
                  <Form.Label>Nome da configuração</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex.: Email principal da empresa"
                    value={nome}
                    onChange={(e) => {
                      setNome(e.target.value);
                      setAlertaConflito("");
                    }}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="formSituacao">
                  <Form.Label>Situação</Form.Label>
                  <Form.Select value={situacao} onChange={(e) => setSituacao(e.target.value)}>
                    <option value="A">Ativa</option>
                    <option value="I">Inativa</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </section>

          <div data-tour="email-servidor-autenticacao">
          <section className="email-config-card">
            <div className="email-config-section-title">
              <FiServer aria-hidden="true" />
              <div>
                <h3>Servidor e conexão</h3>
                <p>Dados técnicos fornecidos pelo serviço de email.</p>
              </div>
            </div>
            <Row className="g-3">
              <Col lg={6}>
                <Form.Group controlId="formServidor">
                  <Form.Label>Servidor</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex.: smtp.gmail.com"
                    value={servidor}
                    onChange={(e) => setServidor(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col sm={8} lg={4}>
                <Form.Group controlId="formSegurancaConexao">
                  <Form.Label>Segurança da conexão</Form.Label>
                  <Form.Select
                    value={segurancaConexao}
                    onChange={(e) => setSegurancaConexao(e.target.value)}
                  >
                    <option value="NENHUM">Nenhuma</option>
                    <option value="SSL/TSL">SSL/TLS</option>
                    <option value="STARTTLS">STARTTLS</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col sm={4} lg={2}>
                <Form.Group controlId="formPorta">
                  <Form.Label>Porta</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="465"
                    value={porta}
                    onChange={(e) => setPorta(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
          </section>

          <section className="email-config-card">
            <div className="email-config-section-title">
              <FiLock aria-hidden="true" />
              <div>
                <h3>Autenticação</h3>
                <p>Credenciais utilizadas para autorizar o envio.</p>
              </div>
            </div>
            <Row className="g-3">
              <Col md={6}>
                <Form.Group controlId="formUsuario">
                  <Form.Label>Usuário ou email remetente</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="remetente@empresa.com.br"
                    value={usuario}
                    onChange={(e) => setUsuario(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Senha
                  id="formSenha"
                  label="Senha"
                  placeholder="Informe a senha"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                />
              </Col>
              <Col xs={12}>
                <Form.Group controlId="formMetodoAutenticacao">
                  <Form.Label>Método de autenticação</Form.Label>
                  <Form.Select
                    value={metodoAutenticacao}
                    onChange={(e) => setMetodoAutenticacao(e.target.value)}
                  >
                    <option value="SEM_AUTENTICACAO">Sem autenticação</option>
                    <option value="SENHA_NORMAL">Senha normal</option>
                    <option value="SENHA_CRIPTOGRAFADA">Senha criptografada</option>
                    <option value="KERBEROS/GSSAPI">Kerberos/GSSAPI</option>
                    <option value="NTLM">NTLM</option>
                    <option value="OAUTH2_MICROSOFT_GRAPH">
                      OAuth2 — Microsoft Graph (corporativo)
                    </option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </section>
          </div>

          {exibirSenhaApp && (
            <section className="email-config-card email-config-card--info">
              <div className="email-config-section-title">
                {provedorDetectado === "google" && <GoogleGIcon />}
                {provedorDetectado === "microsoft" && <MicrosoftIcon />}
                {!provedorDetectado && <FiKey aria-hidden="true" />}
                <div>
                  <h3>Senha de aplicativo</h3>
                  <p>
                    {provedorDetectado === "google"
                      ? "Use a senha de 16 dígitos quando a conta Google tiver verificação em duas etapas."
                      : provedorDetectado === "microsoft"
                      ? "Use a senha gerada pela Microsoft para contas pessoais com autenticação em dois fatores."
                      : "Use quando o provedor exigir uma credencial específica para aplicativos."}
                  </p>
                </div>
              </div>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Group controlId="formAppName">
                    <Form.Label>Nome do aplicativo</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ex.: Doc"
                      value={appName}
                      onChange={(e) => setAppName(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Senha
                    id="formAppSenha"
                    label="Senha de aplicativo"
                    placeholder={provedorDetectado === "google" ? "xxxx xxxx xxxx xxxx" : "Senha gerada pelo provedor"}
                    value={appSenha}
                    onChange={(e) => setAppSenha(e.target.value)}
                  />
                </Col>
              </Row>
              <div className="email-config-help-links">
                {provedorDetectado === "google" && (
                  <a
                    href="https://support.google.com/accounts/answer/185833?p=InvalidSecondFactor"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Como gerar uma Senha de App no Google <FiExternalLink />
                  </a>
                )}
                {provedorDetectado === "microsoft" && (
                  <a
                    href="https://account.microsoft.com/security"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Opções de segurança da conta Microsoft <FiExternalLink />
                  </a>
                )}
              </div>
            </section>
          )}

          {metodoAutenticacao === "OAUTH2_MICROSOFT_GRAPH" && (
            <section className="email-config-card email-config-card--oauth">
              <div className="email-config-section-title">
                <MicrosoftIcon />
                <div>
                  <h3>Microsoft Graph API</h3>
                  <p>Autenticação moderna para Microsoft 365 corporativo, sem SMTP AUTH.</p>
                </div>
              </div>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Group controlId="formOauth2TenantId">
                    <Form.Label>Tenant ID</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Directory ID do Azure AD"
                      value={oauth2TenantId}
                      onChange={(e) => setOauth2TenantId(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formOauth2ClientId">
                    <Form.Label>Client ID</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Application ID"
                      value={oauth2ClientId}
                      onChange={(e) => setOauth2ClientId(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12}>
                  <Senha
                    id="formOauth2ClientSecret"
                    label="Client Secret"
                    placeholder="Valor gerado em Certificados e Segredos"
                    value={oauth2ClientSecret}
                    onChange={(e) => setOauth2ClientSecret(e.target.value)}
                  />
                </Col>
              </Row>
              <details className="email-config-details">
                <summary>
                  <FiInfo aria-hidden="true" />
                  Ver passo a passo para configurar no Azure
                </summary>
                <ol>
                  <li>Abra ou crie o aplicativo em Registro de Aplicativos.</li>
                  <li>Copie o Client ID e o Tenant ID na tela Visão geral.</li>
                  <li>Crie um segredo em Certificados e Segredos.</li>
                  <li>Copie imediatamente a coluna Valor, não o ID do Segredo.</li>
                  <li>Adicione a permissão de aplicativo Microsoft Graph Mail.Send.</li>
                  <li>Conceda o consentimento de administrador para o tenant.</li>
                </ol>
                <a
                  href="https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationsListBlade"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Abrir Registro de Aplicativos no Azure <FiExternalLink />
                </a>
              </details>
            </section>
          )}
        </Form>
      </Modal.Body>

      <Modal.Footer className="modal-footer-padrao email-config-footer">
        <div className="modal-footer-acoes-esquerda">
          <FiShield size={15} aria-hidden="true" />
          <span>Esta configuração será usada nos alertas automáticos da entidade.</span>
        </div>
        <div className="modal-footer-acoes-direita">
          <Cancelar onClick={handleClose} />
          <Salvar onClick={handleSave} />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EmailNotificacaoModal;
